module.exports = __webpack_public_path__ + "media/flags/costa-rica-32-c7e69a62.png";